import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: "app-image-viewer",
  templateUrl: "./image-viewer.component.html",
  styleUrls: ["./image-viewer.component.scss"]
})
export class ImageViewerComponent implements OnInit {
  dataImage;
  datapath;
  Image;

  constructor(
    public dialogRef: MatDialogRef<ImageViewerComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    console.log(data);
    this.dataImage = data.images;
    this.datapath = data.slide;

    //  this.dataImage = this.dataImage[0]

    //  this.dataImage = this.dataImage.map(
    //    item => ({
    //        media_class: "",
    //        media_date: "",
    //        media_desc: "",
    //        media_file: "",
    //        media_id: "",
    //        media_name: "",
    //        media_path: this.datapath,
    //        media_status: ""
    //      })
    //  );
  }

  ngOnInit() {}
  onNoClick(): void {
    this.dialogRef.close();
  }

  indexTracker(index: number, image: any) {
    return index;
  }
}
